
<div>
    <d-contract-mnt-edit
        v-model      = "edit"
        :contract-id = "contract ? contract.id : null"
        :company-id  = "contract && contract.company ? contract.company.id : null"
        @saved       = "onSaved"
    />

    <c-list-card
        :icon       = "icon"
        :background = "background"
        :height     = "166"
        :edit       = "editable"
        :border     = "border"
        :border-width = "borderWidth"
        @edit       = "onEdit"
        @selected   = "onSelect"
    >
        <template v-slot:title>
            <div class="card-title">
                {{ contract.id }} - {{ contract.contracttype ? contract.contracttype.name : '' }}
            </div>
            <v-spacer></v-spacer>
            <company-tag
                v-if       = "showLabels"
                :label     = "$t('msd.service.role.mnt.label')"
                :active    = "contract.active"
                :company   = "contract.company"
                :highlight = "company && contract.company.id === company.id"
            />
            <company-tag
                v-if="contract.service && showLabels"
                :label     = "$t('msd.service.role.srv.label')"
                :active    = "contract.active"
                :company   = "contract.service"
                :highlight = "company && contract.service.id === company.id"
            />
            <company-tag
                v-if       = "contract.prmRole && showLabels"
                :label     = "$t('msd.service.role.adm.label')"
                :active    = "contract.active"
                :highlight = "company && contract.prmRole.id === company.id"
                :company   = "contract.prmRole"
            />
        </template>

        <template v-slot:subtitle>
            <div class="primary--text customer-name">
                {{ contract.customer ? contract.customer.name : '' }}
            </div>
        </template>

        <template v-slot:body>
            <v-row class="no-frame card-subtitle mt-1">
                <v-col class="no-frame col-12 flex-panel pl-0" >
                    <c-tag
                        class="flex-tag"
                        :label="$t('contract.mnt.rentIncluded')"
                        :active="contract.rentIncluded"
                    />
                    <c-tag
                        class="flex-tag"
                        :label="$t('contract.mnt.standByIncluded')"
                        :active="contract.standByIncluded"
                    />
                    <c-tag
                        class="flex-tag"
                        :label="$t('contract.mnt.teleserviceIncluded')"
                        :active="contract.teleserviceIncluded"
                    />
                    <c-tag
                        class="flex-tag"
                        :label="$t('contract.mnt.inspectionIncluded')"
                        :active="contract.inspectionIncluded"
                    />
                    <c-tag
                        class="flex-tag"
                        :label="$t('contract.mnt.phoneIncluded')"
                        :active="contract.phoneIncluded"
                    />
                    <c-tag
                        class="flex-tag"
                        :label="$t('contract.mnt.guardIncluded')"
                        :active="contract.guardIncluded"
                    />
                    <c-tag
                        class="flex-tag"
                        :label="$t('contract.mnt.smokeextractionIncluded')"
                        :active="contract.smokeextractionIncluded"
                    />
                    <c-tag
                        class="flex-tag"
                        :label="$t('contract.mnt.inspectioAddOnIncluded')"
                        :active="contract.inspectioAddOnIncluded"
                    />
                    <c-tag
                        class="flex-tag"
                        :label="$t('contract.mnt.incidentIncluded')"
                        :active="contract.incidentsIncluded"
                    />
                </v-col>
            </v-row>
            <p-contract-condition
                class="mt-2"
                :contract = "contract"
            />
         </template>
    </c-list-card>
</div>
